module.exports = __webpack_public_path__ + "static/media/imge-9.629ece03.jpg";